import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';

import { is3pProductKey } from '../../constants/product-keys';
import type { ResultType } from '../quick-find/analytics';

export const shouldOpenQuickFindResultInNewTab = (
	product: string | undefined,
	resultType: ResultType,
): boolean =>
	Boolean(
		['searchResults', 'recentActivities', 'recommendations'].includes(resultType) &&
		product &&
		is3pProductKey(product) &&
		// Statsig dedupes repeated exposures from row renders.
		expVal<boolean>('rovo_qf_3p_open_in_new_tab', 'isEnabled', false),
	);
